import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  SelectProps
} from '@mui/material'
import { FC, useMemo } from 'react'

import { UserProfile } from '../../../sdk'
import { ModifyObjectType } from '../../../utils'

type Props = ModifyObjectType<
  SelectProps,
  {
    advisor: string | undefined
    advisorOptions: UserProfile[]
    handleAdvisorChange: (event: SelectChangeEvent<unknown>) => void
  }
>

export const AdvisorSelectUI: FC<Props> = ({
  advisor,
  advisorOptions,
  handleAdvisorChange,
  ...props
}) => {
  // handle archived advisor
  const modifiedAdvisorOptions: UserProfile[] = useMemo(() => {
    const options = [...advisorOptions]
    const optionIds = (advisorOptions || []).map((t) => t.id!)
    if (advisor && !optionIds.includes(advisor)) {
      options.push({ id: advisor, name: 'Deleted Service Advisor' })
    }
    return options
  }, [advisor, advisorOptions])

  return (
    <FormControl
      variant="standard"
      size="small"
      data-testid="advisorSelect"
      disabled={props.disabled}
      sx={{ minWidth: 10 }}>
      <Select
        label="Advisor"
        id="advisor"
        data-testid="RepairOrderAdvisorInput"
        value={advisor || ''}
        onChange={handleAdvisorChange}
        {...props}>
        {modifiedAdvisorOptions.map((user) => (
          <MenuItem key={user.id!} value={user.id!} data-testid={user.id!}>
            {user.name!}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
